import { render, staticRenderFns } from "./BusquedaDeProducto.vue?vue&type=template&id=4c35c9df&scoped=true&"
import script from "./BusquedaDeProducto.vue?vue&type=script&lang=js&"
export * from "./BusquedaDeProducto.vue?vue&type=script&lang=js&"
import style0 from "./BusquedaDeProducto.vue?vue&type=style&index=0&id=4c35c9df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c35c9df",
  null
  
)

export default component.exports